import React from "react";
import { Portal } from "@mui/base";

export const MuiPortal = ({ children }) => {
    return <Portal>{children}</Portal>;
};